import React from "react";
import { Collapse } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

//Import Icons
import Icon from "@ailibs/feather-react-ts";

//import withRouter
import withRouter from "../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";

const Navbar = (props: any) => {
  const { user } = useSelector((state: any) => state.login);
  const location = useLocation();

  return (
    <React.Fragment>
      <div className="topnav">
        <nav
          className="navbar navbar-light navbar-expand-lg topnav-menu"
          id="navigation"
        >

          <Collapse
            isOpen={true}
            className="navbar-collapse"
            id="topnav-menu-content"
          >
            <ul className="navbar-nav">
              {((user.user.user_type == "admin") || (user.user.permission_type == 'admin' && user.user.user_type == 'Client')) && (
                <li
                  className={`nav-item dropdown ${location.pathname === "/branding" ? "active in" : ""
                    }`}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/branding"
                    onFocus={(e) => e.currentTarget.blur()}>
                    <Icon name="command" />{" "}
                    <span>{props.t("Branding")}</span>{" "}
                    {/* <div className="arrow-down"></div> */}
                  </Link>
                </li>
              )}
              {user.user.user_type == "Client" && (
                <li
                  className={`nav-item dropdown ${location.pathname === "/team" ? "active in" : ""
                    }`}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/team"
                    onFocus={(e) => e.currentTarget.blur()}>
                    <Icon name="users" />{" "}
                    <span>{props.t("Team")}</span>{" "}
                    {/* <div className="arrow-down"></div> */}
                  </Link>
                </li>
              )}
              <li
                className={`nav-item dropdown ${location.pathname === "/clients" ? "active in" : ""
                  }`}
              >
                <Link
                  className="nav-link dropdown-toggle arrow-none"
                  to="/clients"
                  onFocus={(e) => e.currentTarget.blur()}>
                  <Icon name="list" />{" "}
                  <span>{props.t("Clients")}</span>{" "}
                  {/* <div className="arrow-down"></div> */}
                </Link>
              </li>
              {user.user.user_type != "Client" && (
                <li
                  className={`nav-item dropdown ${location.pathname === "/user-list" ? "active in" : ""
                    }`}
                >
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/user-list"
                    onFocus={(e) => e.currentTarget.blur()}>
                    <Icon name="users" />{" "}
                    <span>{props.t("Client Users")}</span>{" "}
                    {/* <div className="arrow-down"></div> */}
                  </Link>
                </li>
              )}

              {user.user.user_type == "Client" && (
                <>
                  <li
                    className={`nav-item dropdown ${location.pathname === "/billing" ? "active in" : ""
                      }`}
                  >
                    <Link
                      className="nav-link dropdown-toggle arrow-none "
                      to="/billing"
                      onFocus={(e) => e.currentTarget.blur()}
                    >

                      <i className="far fa-money-bill-alt"></i> &nbsp;
                      <span>{props.t("Billing")}</span>{" "}
                      {/* <div className="arrow-down"></div> */}
                    </Link>

                  </li>
                  <li
                    className={`nav-item dropdown ${location.pathname === "/data-options" ? "active in" : ""
                      }`}
                  >
                    <Link
                      className="nav-link dropdown-toggle arrow-none "
                      to="/data-options"
                      onFocus={(e) => e.currentTarget.blur()}
                    >
                      <Icon name="database" />{" "}
                      <span>{props.t("Data options")}</span>{" "}
                    </Link>

                  </li>
                </>
              )}

            </ul>
          </Collapse>
        </nav>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(withRouter(Navbar));
